<template>
  <div class="menu u-row u-middle" :class="{'menu--open':open}">
    <!-- Sound -->
    <!-- <div class="menu__nav menu__nav--min menu__sound u-bg-grey u-cursor-pointer">
      <div class="u-box-1by1">
        <div class="menu__nav--min__item u-wrapper-panel u-row u-middle">
          <img src="/images/btn-sound--off.png" class="u-fit-contain">
        </div>
      </div>
    </div> -->
    <!-- NAV -->
    <div class="menu__nav u-bg-grey">
      <div class="u-box-1by1">
        <div
          v-for="(redirect, index) of redirects"
          class="menu__nav__item u-wrapper-panel u-row u-middle u-cursor-pointer"
          :class="{'is-active': index === currentRedirectIndex, 'u-pointer-none': index !== currentRedirectIndex}"
          @click="onClick(redirect.target)"
        >
          <img :src="'/images/' + redirect.icon" class="u-fit-contain">
          <div v-if="$device.isMobile && redirect.target === 'city' && redirect.origin !== 'map'" class="menu__nav__cross u-bg-grey u-absolute u-w3of8 u-h3of8 u-flex u-middle u-center u-round">
            <img src="/images/cross.svg" alt="Cross icon" class="u-w3of8">
          </div>
        </div>
      </div>
    </div>
    <!-- Socials -->
    <!-- <div @click.stop="()=>{}" class="menu__nav menu__nav--min u-bg-grey u-marg-l-md" v-for="social in socials">
      <div class="u-box-1by1">
        <a :href="social.url" target="_blank" class="menu__nav--min__item u-wrapper-panel u-row u-middle">
          <img :src="'/images/' + social.icon" class="u-fit-contain">
        </a>
      </div>
    </div> -->
    <div class="menu__nav menu__nav--min u-bg-grey u-marg-l-md u-marg-l-sm--xs u-cursor-pointer">
      <div class="u-box-1by1">
        <div id="intercom" @click="$ga.send('Menu', 'Click', 'Intercom')" class="menu__nav--min__item u-wrapper-panel u-row u-middle">
          <img src="/images/intercom.svg" class="u-fit-contain">
        </div>
      </div>
    </div>
    <!-- <div class="menu__more u-center u-middle u-white u-bg-grey" @click="open = !open">{{ open ? '-' : '+' }}</div> -->
  </div>
</template>

<script>
export default {
   data () {
    return {
      open: false,
    }
  },
  computed : {
    socials () {
      return this.$store.getters['global/socials']
    },
    redirects () {
      return this.$store.getters['global/redirects']
    },
    currentRedirectIndex () {
      for(let i = 0 ; i < this.redirects.length ; i++) {
        if (this.$route.name.includes(this.redirects[i].origin)) {
          return i
        }
      }
    }
  },
  methods: {
    onClick (target) {
      if (target === 'map') {
        this.$ga.send('Menu', 'Click', 'Map')
      }
      this.$router.push(this.$local(target))
    }
  }
}
</script>

<style lang="stylus">
@import '~@/styles/settings/mixins/viewport-sizer'
@import '~@/styles/settings/variables'
@import '~@/styles/settings/easings'

.menu
  position absolute
  bottom: $spacings.md
  left: $spacings.md
  
  &__sound
    position absolute
    top -80px
    left 23px
  
  &__nav
    width 90px
    border-radius 50%
    transition transform .15s ease-out


    &:hover
      transform scale(1.1) translateZ(0)

    @media ( max-width: $mq-breakpoints.tablet )
      transform scale(1)
      
    @media ( max-width: $mq-breakpoints.mobile )
      width 60px
      
    &--min
      width 50px
      
      &__item
        padding 15px
    
    &__item
      padding 0 30px
      opacity 0
      transform scale(.5) translateZ(0)
      transition opacity .3s linear, transform .3s ease-in-out-quad
      
      @media ( max-width: $mq-breakpoints.mobile )
        padding 0 20px
    
      &.is-active
        opacity 1
        transform scale(1) translateZ(0)
        transition opacity .3s .3s linear, transform .3s .3s ease-in-out-quad

    // &--min
    //   @media ( max-width: $mq-breakpoints.tablet )
    //     position absolute
    //     z-index -1
    //     transition .15s ease-out
    //     opacity 0
    //     &:nth-child(1)
    //       top 0

    &__cross
      top -5px
      right -5px
      
  &__more
    display none
    @media ( max-width: $mq-breakpoints.tablet )
      display flex
      position absolute
      height 30px
      width 30px
      bottom 5px
      right 5px
      border-radius 50%
      background $gradients.pink-orange
      z-index 1
      &:before
        content: ''
        z-index -1
        position: absolute
        top: 0; 
        right: 0; 
        bottom: 0; 
        left: 0;
        margin: 2px;
        border-radius: inherit;
        background: $colors.grey    
        border-radius: 100px

.menu--open
  @media ( max-width: $mq-breakpoints.tablet )
    for row in 2 3 4 5
      .menu__nav--min:nth-child({row})
        transform translateX((60px * row) - 110)
        z-index 1
        transition .15s ease-out
        transition-delay .05s * row
        top 20px
        opacity 1
    for row in 1
      .menu__nav--min:nth-child({row})
        transform translateY(60px)
        z-index 1
        transition .15s ease-out
        transition-delay .05s * row
        top -120px
        opacity 1


</style>